import { Component, OnInit, Input, ChangeDetectionStrategy } from "@angular/core";

import { BaseComponent, CheckoutService, StorageService, UserService } from "@mypxplat/xplat/core";
import { Router, RouterEvent, NavigationEnd } from "@angular/router";
import moment from "moment";
import { AppService } from "@mypxplat/xplat/web/core";
import { UpdatePaymentSourceStripeComponent } from "../modals";
import { take } from "rxjs";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-missed-payment-notice",
  templateUrl: "missed-payment-notice.component.html",
  standalone: false,
})
export class MissedPaymentNotice extends BaseComponent {
  @Input() missedPaymentDetails: any;

  constructor(
    public storage: StorageService,
    public userService: UserService,
    public appService: AppService,
    public checkoutService: CheckoutService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.userService.getSubscriptionDetails(true).subscribe((result) => {
      if (this.missedPaymentDetails?.charge && this.userService.subDetails?.subscription?.provider == "stripe") {
        this.checkoutService.getCharge(this.missedPaymentDetails.charge).subscribe((result) => {
          this.missedPaymentDetails.charge_data = result;
        });
      }
    });
  }

  showAddCardModal() {
    const modalRef = this.appService.showModal(UpdatePaymentSourceStripeComponent, { size: "lg" });
    modalRef.componentInstance.cardAdded.pipe(take(1)).subscribe(() => {
      this.userService.getSubscriptionDetails(true).subscribe();
    });
  }

  goToAddPaymentMethod() {
    window.location.assign("/paymentmethods");
  }
}
